import styled from 'react-emotion'
import { mediaDn, spacer } from 'stylist'

const Platforms = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @supports (display: grid) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: ${spacer(4)};
    justify-content: unset;

    ${mediaDn('md')} {
      grid-template-columns: 1fr;
    }
  }
`

export default Platforms



// WEBPACK FOOTER //
// ./src/routes/home/components/Platforms.js